import { useInboxUIStore } from '../stores/inboxUIStore';

export const DEFAULT_HOME_PATH = '/members';
export const INBOX_HOME_PATH = '/inbox';

/**
 * Where the app sends someone who arrives without a destination — a fresh
 * login, or the bare domain. Read at the moment of the redirect rather than
 * subscribed to, so changing the preference mid-session never navigates.
 */
export function getHomePath(): string {
  return useInboxUIStore.getState().isInboxHome
    ? INBOX_HOME_PATH
    : DEFAULT_HOME_PATH;
}
